import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {LoginComponent} from "./features/auth/login/login.component";
import {KdDashboardComponent} from "./features/knowledge-database/kd-dashboard/kd-dashboard.component";
import {ErDashboardComponent} from "./features/error-report/er-dashboard/er-dashboard.component";
import {DashboardComponent} from "./features/dashboard/dashboard.component";
import {ReportComponent} from "./features/report/report.component";
import {WorkplacesComponent} from "./features/workplaces/workplaces.component";
import {WorkplaceSelectionComponent} from "./features/workplace-selection/workplace-selection.component";
import {adminGuard} from "./core/guards/admin.guard";
import {ResetPasswordComponent} from "./features/auth/reset-password/reset-password.component";
import {useractiveGuard} from "./core/guards/useractive.guard";
import {passwordUpdateRequiredGuard} from "./core/guards/password-update-required.guard";
import {KdSolutionComponent} from "./features/knowledge-database/kd-solution/kd-solution.component";
import {selectWorkplaceGuard} from "./core/guards/select-workplace.guard";
import {checkWorkplaceGuard} from "./core/guards/selection-cookies.guard";
import {EscalationComponent} from "./features/escalation/escalation.component";
import {userroleGuard} from "./core/guards/userrole.guard";
import {WorkplaceReportComponent} from "./features/workplace-report/workplace-report.component";
import {authGuard} from "./core/guards/auth.guard";
import {leaveActiveReportGuard} from "./core/guards/leave-active-report.guard";
import {loginGuard} from "./core/guards/login.guard";
import {DailyReportDashboardComponent} from "./features/report-dashboards/daily/daily-dashboard.component";
import {WeeklyReportDashboardComponent} from "./features/report-dashboards/weekly/weekly-dashboard.component";

const routes: Routes = [
  {
    path: "",
    redirectTo: "login",
    pathMatch: "full",
  },
  {
    path: "login",
    component: LoginComponent,
    canActivate: [loginGuard]
  },
  {
    path: "reset-password",
    component: ResetPasswordComponent,
    canActivate: [authGuard, useractiveGuard],
  },
  {
    path: "select",
    component: WorkplaceSelectionComponent,
    canActivate: [
      authGuard,
      useractiveGuard,
      selectWorkplaceGuard,
      passwordUpdateRequiredGuard,
    ],
  },
  {
    path: "kd",
    component: KdDashboardComponent,
    canActivate: [
      authGuard,
      useractiveGuard,
      passwordUpdateRequiredGuard,
      checkWorkplaceGuard,
    ],
  },
  {
    path: "solution",
    component: KdSolutionComponent,
    canActivate: [
      authGuard,
      useractiveGuard,
      passwordUpdateRequiredGuard,
    ]
  },
  {
    path: "er",
    component: ErDashboardComponent,
    canActivate: [
      authGuard,
      useractiveGuard,
      passwordUpdateRequiredGuard,
      checkWorkplaceGuard,
    ],
    canDeactivate: [
      leaveActiveReportGuard
    ]
  },
  {
    path: "dashboard",
    component: DashboardComponent,
    canActivate: [
      authGuard,
      useractiveGuard,
      passwordUpdateRequiredGuard,
      checkWorkplaceGuard,
    ],
  },
  {
    path: "report/:id",
    component: ReportComponent,
    canActivate: [
      authGuard,
      useractiveGuard,
      passwordUpdateRequiredGuard,
      checkWorkplaceGuard,
    ],
  },
  {
    path: "escalations",
    component: EscalationComponent,
    canActivate: [
      authGuard,
      useractiveGuard,
      passwordUpdateRequiredGuard,
      userroleGuard
    ],
  },
  {
    path: "workplaces",
    component: WorkplacesComponent,
    canActivate: [
      authGuard,
      useractiveGuard,
      passwordUpdateRequiredGuard,
      checkWorkplaceGuard,
    ],
  },
  {
    path: "workplace/:id",
    component: WorkplaceReportComponent,
    canActivate: [
      authGuard,
      useractiveGuard,
      passwordUpdateRequiredGuard],
  },
  {
    path: "report-dashboards",
    children: [
      {
        path: "daily",
        component: DailyReportDashboardComponent,
        canActivate: [authGuard]
      },
      {
        path: "weekly",
        component: WeeklyReportDashboardComponent,
        canActivate: [authGuard]
      }
    ]
  },
  {
    path: "admin",
    loadChildren: () =>
      import("./features/admin/admin.module").then((m) => m.AdminModule),
    canActivate: [authGuard, adminGuard, passwordUpdateRequiredGuard],
    canLoad: [authGuard, adminGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
